export default __webpack_public_path__ + "static/media/employees_amount.2da3b364.svg";